export default __webpack_public_path__ + "static/media/MoneyBarn_DSAR.99d77a53.pdf";